export default function FormInput({
  title = "title",
  name = "name",
  placeholder = "",
  type = "text",
  onChange,
  hint,
  value,
  min,
  max,
  step,
  inputMode,
  pattern,
}) {
  return (
    <div>
      <label className="py-2 block">{title}{hint && (<span className="text-xs text-gray-600 pl-3">({hint})</span>)}</label>
      <input
        name={name}
        type={type}
        placeholder={placeholder}
        className="w-80 rounded-md indent-2 p-1 bg-gray-800 border border-gray-700 text-gray-300 mb-2 focus:border-green-400"
        onChange = {onChange}
        value={value}
        min={min}
        max={max}
        step={step}
        inputMode={inputMode}
        pattern={pattern}
      />
    </div>
  );
}
